import React from 'react';
import { Loader } from 'components/loader/loader';
import { useTranslation } from 'react-i18next';
import styles from './processing-overlay.module.scss';

interface ProcessingOverlayProps {
  isVisible: boolean;
  message?: string;
}

export const ProcessingOverlay: React.FC<ProcessingOverlayProps> = ({ isVisible, message }) => {
  const { t } = useTranslation();

  if (!isVisible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.content}>
        <Loader size="medium" />
        {false && (
          <p className={styles.message}>
            {message || t('System is currently processing your request')}
          </p>
        )}
      </div>
    </div>
  );
};
